export const delay = <T>(timeout: number, value?: T) => {
  return new Promise(function(resolve) {
      setTimeout(resolve.bind(null, value), timeout)
  });
}

export const toIsoDateString = () => {
  const iso = new Date().toISOString();
  return iso.substring(0, iso.indexOf('T'));
}